import { Outlet, useLocation } from 'react-router';
import { TopNav } from './TopNav';
import { InfoPanel } from './InfoPanel';
import { MobileBottomNav } from './MobileBottomNav';
import { OfflineBanner } from '@/components/OfflineBanner';
import { ConnectivityBanner } from '@/components/ConnectivityBanner';
import { useDashboardSSE } from '@/hooks/useDashboardSSE';
import { OutcomesSidebar } from '@/components/outcomes/sidebar/OutcomesSidebar';
import { GBrainSidebar } from '@/components/g-brain/sidebar/GBrainSidebar';
import { IntelSidebar } from '@/components/intelligence/sidebar/IntelSidebar';

/** Event name the bottom-nav Menu button dispatches to open the chat conversation drawer. */
export const OPEN_CONVERSATION_DRAWER_EVENT = 'maestro:open-conversation-drawer';

export function Layout(): React.ReactElement {
  const { status: dashboardStatus } = useDashboardSSE();
  const { pathname } = useLocation();
  const isOutcomesRoute = pathname.startsWith('/outcomes');
  const isGBrainRoute = pathname.startsWith('/g-brain');
  const isIntelRoute = pathname.startsWith('/intelligence');
  const hasSidebar = isOutcomesRoute || isGBrainRoute || isIntelRoute;

  const handleOpenMenu = (): void => {
    window.dispatchEvent(new CustomEvent(OPEN_CONVERSATION_DRAWER_EVENT));
  };

  return (
    <div className="flex h-screen flex-col bg-background">
      <ConnectivityBanner />
      {dashboardStatus === 'error' && (
        <div className="border-b border-border bg-warning px-4 py-2 text-center text-sm font-medium text-background">
          Live updates disconnected — retrying…
        </div>
      )}
      <OfflineBanner />
      <TopNav />
      <main className={`flex flex-1 overflow-hidden ${hasSidebar ? 'flex-row' : 'flex-col'}`}>
        {isOutcomesRoute && <OutcomesSidebar />}
        {isGBrainRoute && <GBrainSidebar />}
        {isIntelRoute && <IntelSidebar />}
        <div className="flex flex-1 flex-col overflow-hidden">
          <Outlet />
        </div>
      </main>
      <MobileBottomNav onOpenMenu={handleOpenMenu} />
      <InfoPanel />
    </div>
  );
}
